import { api } from "@/lib/api";

// Obsidian-style links inside note/annotation text: [[Document or Concept]].
const WIKILINK = /\[\[([^\]]+)\]\]/g;

export function parseWikilinks(text: string): string[] {
  const out = new Set<string>();
  let m: RegExpExecArray | null;
  WIKILINK.lastIndex = 0;
  while ((m = WIKILINK.exec(text)) !== null) {
    const label = (m[1] ?? "").trim();
    if (label) out.add(label);
  }
  return [...out];
}

/** Resolve each [[label]] in `text` to a node and create an edge from
 *  `sourceNodeId` to it — no dialog, just like Obsidian. Unresolved labels are
 *  left as plain text. Returns how many links were formed. */
export async function linkWikilinks(
  sourceNodeId: string,
  text: string,
  edgeType = "about",
): Promise<number> {
  let made = 0;
  for (const label of parseWikilinks(text)) {
    const node = await api
      .request<{ id: string } | null>("GET", `/api/nodes/resolve?label=${encodeURIComponent(label)}`)
      .catch(() => null);
    if (!node?.id || node.id === sourceNodeId) continue;
    try {
      await api.request("POST", "/api/edges", { src_id: sourceNodeId, dst_id: node.id, type: edgeType });
      made++;
    } catch {
      /* ontology rejection or duplicate edge — skip silently */
    }
  }
  return made;
}
